module.exports = __webpack_public_path__ + "media/rings.5da21562.mp3";